// @flow

import _ from 'lodash/fp';
import {GET, POST, PUT} from '../helpers/request';
import {ADD as NOTIFICATION} from './notification';
import {STANDARD} from '../assortments';
import {
  filterAndSort,
  sortByName,
} from './apartmentConfigView';
import type {Dispatch} from 'redux';
import type {Exact} from '../reducers/configTemplateView';
import type {OptionalNavigationAction} from './notification';
import type {
  RoomTemplateDto,
  ErrorDto,
  ProductDto,
  ProductSlotDto,
  ProductTypeDto,
  RoomTypeDto,
  VariantDto,
  LimitedProjectDto,
} from '../dtos';

export const GET_REQUEST = '@roomTemplateView/GET_REQUEST';
export const GET_SUCCESS = '@roomTemplateView/GET_SUCCESS';
export const GET_FAILURE = '@roomTemplateView/GET_FAILURE';

export const UPDATE_REQUEST = '@roomTemplateView/UPDATE_REQUEST';
export const UPDATE_SUCCESS = '@roomTemplateView/UPDATE_SUCCESS';
export const UPDATE_FAILURE = '@roomTemplateView/UPDATE_FAILURE';

export const CREATE_REQUEST = '@roomTemplateView/CREATE_REQUEST';
export const CREATE_SUCCESS = '@roomTemplateView/CREATE_SUCCESS';
export const CREATE_FAILURE = '@roomTemplateView/CREATE_FAILURE';

export const PRODUCT_SLOT_UPDATE_REQUEST = '@roomTemplateView/PRODUCT_SLOT_UPDATE_REQUEST';
export const PRODUCT_SLOT_UPDATE_SUCCESS = '@roomTemplateView/PRODUCT_SLOT_UPDATE_SUCCESS';
export const PRODUCT_SLOT_UPDATE_FAILURE = '@roomTemplateView/PRODUCT_SLOT_UPDATE_FAILURE';

export const PRODUCT_SLOT_CREATE_REQUEST = '@roomTemplateView/PRODUCT_SLOT_CREATE_REQUEST';
export const PRODUCT_SLOT_CREATE_SUCCESS = '@roomTemplateView/PRODUCT_SLOT_CREATE_SUCCESS';
export const PRODUCT_SLOT_CREATE_FAILURE = '@roomTemplateView/PRODUCT_SLOT_CREATE_FAILURE';

export const SELECT_PRODUCT_SLOT = '@roomTemplateView/SELECT_PRODUCT_SLOT';
export const RESET = '@roomTemplateView/RESET';
export const CLEAR = '@roomTemplateView/CLEAR';

export const OPEN_DIALOG_REQUEST = '@roomTemplateView/OPEN_DIALOG_REQUEST';
export const OPEN_DIALOG_FAILURE = '@roomTemplateView/OPEN_DIALOG_FAILURE';
export const OPEN_DIALOG_SUCCESS = '@roomTemplateView/OPEN_DIALOG_SUCCESS';
export const CLOSE_DIALOG = '@roomTemplateView/CLOSE_DIALOG';
export const POP_DIALOG_NAVIGATION = '@roomTemplateView/POP_DIALOG_NAVIGATION';
export const NAVIGATE_TO_VARIANT_REQUEST = '@roomTemplateView/NAVIGATE_TO_VARIANT_REQUEST';
export const NAVIGATE_TO_VARIANT_FAILURE = '@roomTemplateView/NAVIGATE_TO_VARIANT_FAILURE';
export const NAVIGATE_TO_VARIANT_SUCCESS = '@roomTemplateView/NAVIGATE_TO_VARIANT_SUCCESS';
export const UPDATE_RELATED_VARIANT = '@roomTemplateView/UPDATE_RELATED_VARIANT';
export const TOGGLE_VARIANT_REQUEST = '@roomTemplateView/TOGGLE_VARIANT_REQUEST';
export const TOGGLE_VARIANT_FAILURE = '@roomTemplateView/TOGGLE_VARIANT_FAILURE';
export const TOGGLE_VARIANT_SUCCESS = '@roomTemplateView/TOGGLE_VARIANT_SUCCESS';
export const SET_STANDARD_PRODUCT = '@roomTemplateView/SET_STANDARD_PRODUCT';
export const TOGGLE_PRODUCT = '@roomTemplateView/TOGGLE_PRODUCT';
export const CHECK_ALL_VARIANTS = '@roomTemplateView/CHECK_ALL_VARIANTS';
export const CLEAR_STANDARD_PRODUCT = '@roomTemplateView/CLEAR_STANDARD_PRODUCT';
export const CHECK_PRODUCT = '@roomTemplateView/CHECK_PRODUCT';
export const UPDATE_VARIANTS = '@roomTemplateView/UPDATE_VARIANTS';
export const PRODUCT_SLOTS_UPDATE_REQUEST = '@roomTemplateView/PRODUCT_SLOTS_UPDATE_REQUEST';
export const PRODUCT_SLOTS_UPDATE_FAILURE = '@roomTemplateView/PRODUCT_SLOTS_UPDATE_FAILURE';
export const PRODUCT_SLOTS_UPDATE_SUCCESS = '@roomTemplateView/PRODUCT_SLOTS_UPDATE_SUCCESS';
export const UPDATE_VARIANTS_FOR_TYPE = '@roomTemplateView/UPDATE_VARIANTS_FOR_TYPE';

export type RoomTemplateViewGetRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/GET_REQUEST',
};
export type RoomTemplateViewGetSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/GET_SUCCESS',
  roomTemplate: ?RoomTemplateDto,
  roomTypes: RoomTypeDto[],
  products: ProductDto[],
  productTypes: ProductTypeDto[],
  roomTemplates: RoomTemplateDto[],
  projects: LimitedProjectDto[],
};
export type RoomTemplateViewGetFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/GET_FAILURE',
  error: ErrorDto,
};

export type RoomTemplateViewUpdateRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/UPDATE_REQUEST',
};
export type RoomTemplateViewUpdateSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/UPDATE_SUCCESS',
  roomTemplate: RoomTemplateDto,
};
export type RoomTemplateViewUpdateFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/UPDATE_FAILURE',
  error: ErrorDto,
};

export type RoomTemplateViewCreateRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CREATE_REQUEST',
};
export type RoomTemplateViewCreateSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CREATE_SUCCESS',
  roomTemplate: RoomTemplateDto,
};
export type RoomTemplateViewCreateFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CREATE_FAILURE',
  error: ErrorDto,
};

export type RoomTemplateViewProductSlotUpdateRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOT_UPDATE_REQUEST',
};
export type RoomTemplateViewProductSlotUpdateSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOT_UPDATE_SUCCESS',
  productSlot: ProductSlotDto,
};
export type RoomTemplateViewProductSlotUpdateFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOT_UPDATE_FAILURE',
  error: ErrorDto,
};

export type RoomTemplateViewProductSlotCreateRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOT_CREATE_REQUEST',
};
export type RoomTemplateViewProductSlotCreateSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOT_CREATE_SUCCESS',
  productSlot: ProductSlotDto,
  roomTemplateId: number,
};
export type RoomTemplateViewProductSlotCreateFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOT_CREATE_FAILURE',
  error: ErrorDto,
};

export type RoomTemplateViewSelectProductSlotAction = OptionalNavigationAction & {
  type: '@roomTemplateView/SELECT_PRODUCT_SLOT',
  productSlot: ?ProductSlotDto,
};
export type RoomTemplateViewResetAction = OptionalNavigationAction & {
  type: '@roomTemplateView/RESET',
};
export type RoomTemplateViewClearAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CLEAR',
};

export type RoomTemplateViewOpenDialogRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/OPEN_DIALOG_REQUEST',
};
export type RoomTemplateViewOpenDialogFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/OPEN_DIALOG_FAILURE',
  error: ErrorDto,
};
export type RoomTemplateViewOpenDialogSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/OPEN_DIALOG_SUCCESS',
  products: ProductDto[],
  rootName: string,
  productType: ProductTypeDto,
};
export type RoomTemplateViewCloseDialogAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CLOSE_DIALOG',
};
export type RoomTemplateViewPopDialogNavigationAction = OptionalNavigationAction & {
  type: '@roomTemplateView/POP_DIALOG_NAVIGATION',
  depth: number,
};
export type RoomTemplateViewNavigateToVariantRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/NAVIGATE_TO_VARIANT_REQUEST',
};
export type RoomTemplateViewNavigateToVariantFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/NAVIGATE_TO_VARIANT_FAILURE',
  error: ErrorDto,
};
export type RoomTemplateViewNavigateToVariantSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/NAVIGATE_TO_VARIANT_SUCCESS',
  variant: VariantDto,
};
export type RoomTemplateViewUpdateRelatedVariantAction = OptionalNavigationAction & {
  type: '@roomTemplateView/UPDATE_RELATED_VARIANT',
  variant: VariantDto,
  data: any,
};
export type RoomTemplateViewToggleVariantRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/TOGGLE_VARIANT_REQUEST',
};
export type RoomTemplateViewToggleVariantFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/TOGGLE_VARIANT_FAILURE',
  error: ErrorDto,
};
export type RoomTemplateViewToggleVariantSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/TOGGLE_VARIANT_SUCCESS',
  variant: VariantDto,
  expand: boolean,
};
export type RoomTemplateViewSetStandardProductAction = OptionalNavigationAction & {
  type: '@roomTemplateView/SET_STANDARD_PRODUCT',
  product: ProductDto,
  productType: ProductTypeDto,
};
export type RoomTemplateViewToggleProductAction = OptionalNavigationAction & {
  type: '@roomTemplateView/TOGGLE_PRODUCT',
  product: ProductDto,
};
export type RoomTemplateViewCheckAllVariantsAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CHECK_ALL_VARIANTS',
  checked: boolean,
};
export type RoomTemplateViewClearStandardProductAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CLEAR_STANDARD_PRODUCT',
  productType: ProductTypeDto,
};
export type RoomTemplateViewCheckProductAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CHECK_PRODUCT',
  productId: number,
  checked: boolean,
};
export type RoomTemplateViewUpdateVariantsAction = OptionalNavigationAction & {
  type: '@roomTemplateView/UPDATE_VARIANTS',
  productId: number,
  data: any,
};
export type RoomTemplateViewUpdateVariantsForTypeAction = OptionalNavigationAction & {
  type: '@roomTemplateView/UPDATE_VARIANTS_FOR_TYPE',
  productTypeId: number,
  data: any,
};
export type RoomTemplateViewProductSlotsUpdateRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOTS_UPDATE_REQUEST',
};
export type RoomTemplateViewProductSlotsUpdateFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOTS_UPDATE_FAILURE',
  error: ErrorDto,
};
export type RoomTemplateViewProductSlotsUpdateSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOTS_UPDATE_SUCCESS',
  roomTemplateId: number,
  productSlotId: number,
  productSlots: ProductSlotDto[],
};

export type RoomTemplateViewAction
  = RoomTemplateViewGetRequestAction
  | RoomTemplateViewGetSuccessAction
  | RoomTemplateViewGetFailureAction
  | RoomTemplateViewUpdateRequestAction
  | RoomTemplateViewUpdateSuccessAction
  | RoomTemplateViewUpdateFailureAction
  | RoomTemplateViewCreateRequestAction
  | RoomTemplateViewCreateSuccessAction
  | RoomTemplateViewCreateFailureAction
  | RoomTemplateViewProductSlotUpdateRequestAction
  | RoomTemplateViewProductSlotUpdateSuccessAction
  | RoomTemplateViewProductSlotUpdateFailureAction
  | RoomTemplateViewProductSlotCreateRequestAction
  | RoomTemplateViewProductSlotCreateSuccessAction
  | RoomTemplateViewProductSlotCreateFailureAction
  | RoomTemplateViewSelectProductSlotAction
  | RoomTemplateViewResetAction
  | RoomTemplateViewClearAction
  | RoomTemplateViewOpenDialogRequestAction
  | RoomTemplateViewOpenDialogFailureAction
  | RoomTemplateViewOpenDialogSuccessAction
  | RoomTemplateViewCloseDialogAction
  | RoomTemplateViewPopDialogNavigationAction
  | RoomTemplateViewNavigateToVariantRequestAction
  | RoomTemplateViewNavigateToVariantFailureAction
  | RoomTemplateViewNavigateToVariantSuccessAction
  | RoomTemplateViewUpdateRelatedVariantAction
  | RoomTemplateViewToggleVariantRequestAction
  | RoomTemplateViewToggleVariantFailureAction
  | RoomTemplateViewToggleVariantSuccessAction
  | RoomTemplateViewSetStandardProductAction
  | RoomTemplateViewToggleProductAction
  | RoomTemplateViewCheckAllVariantsAction
  | RoomTemplateViewClearStandardProductAction
  | RoomTemplateViewCheckProductAction
  | RoomTemplateViewUpdateVariantsAction
  | RoomTemplateViewUpdateVariantsForTypeAction
  | RoomTemplateViewProductSlotsUpdateRequestAction
  | RoomTemplateViewProductSlotsUpdateFailureAction
  | RoomTemplateViewProductSlotsUpdateSuccessAction;

const productSlotsUpdateRequest = (): Exact<RoomTemplateViewProductSlotsUpdateRequestAction> => ({
  type: PRODUCT_SLOTS_UPDATE_REQUEST,
});

const productSlotsUpdateFailure = (error: ErrorDto): Exact<RoomTemplateViewProductSlotsUpdateFailureAction> => ({
  type: PRODUCT_SLOTS_UPDATE_FAILURE,
  error,
});

const productSlotsUpdateSuccess = (roomTemplateId: number, productSlotId: number, productSlots: ProductSlotDto[]): Exact<RoomTemplateViewProductSlotsUpdateSuccessAction> => ({
  type: PRODUCT_SLOTS_UPDATE_SUCCESS,
  roomTemplateId,
  productSlotId,
  productSlots,
});

export const updateVariants = (productId: number, data: any): Exact<RoomTemplateViewUpdateVariantsAction> => ({
  type: UPDATE_VARIANTS,
  productId,
  data,
});

export const updateVariantsForType = (productTypeId: number, data: any): Exact<RoomTemplateViewUpdateVariantsForTypeAction> => ({
  type: UPDATE_VARIANTS_FOR_TYPE,
  productTypeId,
  data,
});

export const checkProduct = (productId: number, checked: boolean): Exact<RoomTemplateViewCheckProductAction> => ({
  type: CHECK_PRODUCT,
  productId,
  checked,
});

export const checkAllVariants = (checked: boolean): Exact<RoomTemplateViewCheckAllVariantsAction> => ({
  type: CHECK_ALL_VARIANTS,
  checked,
});

export const toggleProduct = (product: ProductDto): Exact<RoomTemplateViewToggleProductAction> => ({
  type: TOGGLE_PRODUCT,
  product,
});

export const popDialogNavigation = (depth: number): Exact<RoomTemplateViewPopDialogNavigationAction> => ({
  type: POP_DIALOG_NAVIGATION,
  depth,
});

const navigateToVariantRequest = (): Exact<RoomTemplateViewNavigateToVariantRequestAction> => ({
  type: NAVIGATE_TO_VARIANT_REQUEST,
});

const navigateToVariantFailure = (error: ErrorDto): Exact<RoomTemplateViewNavigateToVariantFailureAction> => ({
  type: NAVIGATE_TO_VARIANT_FAILURE,
  error,
});

const navigateToVariantSuccess = (variant: VariantDto): Exact<RoomTemplateViewNavigateToVariantSuccessAction> => ({
  type: NAVIGATE_TO_VARIANT_SUCCESS,
  variant,
});

export const navigateToVariant = (variant: VariantDto) => async (dispatch: Dispatch<RoomTemplateViewAction>) => {
  dispatch(navigateToVariantRequest());
  try {
    const fullVariant = await GET({endpoint: `/productvariants/${variant.id}`}, dispatch);
    dispatch(navigateToVariantSuccess({
      ...fullVariant,
      uuid: variant.uuid,
    }));
  } catch (err) {
    dispatch(navigateToVariantFailure(err));
  }
};

export const updateRelatedVariant = (variant: VariantDto, data: any): Exact<RoomTemplateViewUpdateRelatedVariantAction> => ({
  type: UPDATE_RELATED_VARIANT,
  variant,
  data,
});

export const setStandardProduct = (product: ProductDto, productType: ProductTypeDto): Exact<RoomTemplateViewSetStandardProductAction> => ({
  type: SET_STANDARD_PRODUCT,
  product,
  productType,
});

export const clearStandardProduct = (productType: ProductTypeDto): Exact<RoomTemplateViewClearStandardProductAction> => ({
  type: CLEAR_STANDARD_PRODUCT,
  productType,
});

const toggleVariantRequest = (): Exact<RoomTemplateViewToggleVariantRequestAction> => ({
  type: TOGGLE_VARIANT_REQUEST,
});

const toggleVariantFailure = (error: ErrorDto): Exact<RoomTemplateViewToggleVariantFailureAction> => ({
  type: TOGGLE_VARIANT_FAILURE,
  error,
});

const toggleVariantSuccess = (variant: VariantDto, expand: boolean): Exact<RoomTemplateViewToggleVariantSuccessAction> => ({
  type: TOGGLE_VARIANT_SUCCESS,
  variant,
  expand,
});

export const toggleVariant = (variant: VariantDto, expand: boolean) => async (dispatch: Dispatch<RoomTemplateViewAction>) => {
  if (expand) {
    dispatch(toggleVariantRequest());
    try {
      const fullVariant = await GET({endpoint: `/productvariants/${variant.id}`}, dispatch);
      dispatch(toggleVariantSuccess({
        ...fullVariant,
        uuid: variant.uuid,
      }, expand));
    } catch (err) {
      dispatch(toggleVariantFailure(err));
    }
  } else {
    dispatch(toggleVariantSuccess(variant, expand));
  }
};

const openDialogRequest = (): Exact<RoomTemplateViewOpenDialogRequestAction> => ({
  type: OPEN_DIALOG_REQUEST,
});

const openDialogFailure = (error: ErrorDto): Exact<RoomTemplateViewOpenDialogFailureAction> => ({
  type: OPEN_DIALOG_FAILURE,
  error,
});

const openDialogSuccess = (products: ProductDto[], rootName: string, productType: ProductTypeDto): Exact<RoomTemplateViewOpenDialogSuccessAction> => ({
  type: OPEN_DIALOG_SUCCESS,
  products,
  rootName,
  productType,
});

export const openDialog = (productTypeId: number, rootName: string) => async (dispatch: Dispatch<RoomTemplateViewAction>) => {
  dispatch(openDialogRequest());
  try {
    const productType = await GET({endpoint: `/producttypes/${productTypeId}`}, dispatch);
    const products = await GET({endpoint: `/products?productTypeId=${productTypeId}&assortment=${STANDARD}`}, dispatch);
    dispatch(openDialogSuccess(products, rootName, productType));
  } catch (err) {
    dispatch(openDialogFailure(err));
  }
};

export const closeDialog = (): Exact<RoomTemplateViewCloseDialogAction> => ({
  type: CLOSE_DIALOG,
});

const roomTemplateRequest = (): Exact<RoomTemplateViewGetRequestAction> => ({
  type: GET_REQUEST,
});

const roomTemplateSuccess = (roomTemplate: ?RoomTemplateDto, roomTypes: RoomTypeDto[], products: ProductDto[], productTypes: ProductTypeDto[], roomTemplates: RoomTemplateDto[], projects: LimitedProjectDto[]): Exact<RoomTemplateViewGetSuccessAction> => ({
  type: GET_SUCCESS,
  roomTemplate,
  roomTypes,
  products,
  productTypes,
  roomTemplates,
  projects,
});

const roomTemplateFailure = (error: ErrorDto): Exact<RoomTemplateViewGetFailureAction> => ({
  type: GET_FAILURE,
  error,
});

const roomTemplateUpdateRequest = (): Exact<RoomTemplateViewUpdateRequestAction> => ({
  type: UPDATE_REQUEST,
});

const roomTemplateUpdateSuccess = (roomTemplate: RoomTemplateDto): Exact<RoomTemplateViewUpdateSuccessAction> => ({
  type: UPDATE_SUCCESS,
  roomTemplate,
  [NOTIFICATION]: {
    message: 'Mall uppdaterad',
  },
});

const roomTemplateUpdateFailure = (error: ErrorDto): Exact<RoomTemplateViewUpdateFailureAction> => ({
  type: UPDATE_FAILURE,
  error,
});

const roomTemplateCreateRequest = (): Exact<RoomTemplateViewCreateRequestAction> => ({
  type: CREATE_REQUEST,
});

const roomTemplateCreateSuccess = (roomTemplate: RoomTemplateDto): Exact<RoomTemplateViewCreateSuccessAction> => ({
  type: CREATE_SUCCESS,
  roomTemplate,
  [NOTIFICATION]: {
    message: `Mall "${roomTemplate.name}" skapad`,
  },
});

const roomTemplateCreateFailure = (error: ErrorDto): Exact<RoomTemplateViewCreateFailureAction> => ({
  type: CREATE_FAILURE,
  error,
});

const productSlotUpdateRequest = (): Exact<RoomTemplateViewProductSlotUpdateRequestAction> => ({
  type: PRODUCT_SLOT_UPDATE_REQUEST,
});

const productSlotUpdateSuccess = (productSlot: ProductSlotDto): Exact<RoomTemplateViewProductSlotUpdateSuccessAction> => ({
  type: PRODUCT_SLOT_UPDATE_SUCCESS,
  productSlot,
  [NOTIFICATION]: {
    message: 'Produktplats uppdaterad',
  },
});

const productSlotUpdateFailure = (error: ErrorDto): Exact<RoomTemplateViewProductSlotUpdateFailureAction> => ({
  type: PRODUCT_SLOT_UPDATE_FAILURE,
  error,
});

const productSlotCreateRequest = (): Exact<RoomTemplateViewProductSlotCreateRequestAction> => ({
  type: PRODUCT_SLOT_CREATE_REQUEST,
});

const productSlotCreateSuccess = (productSlot: ProductSlotDto, roomTemplateId: number): Exact<RoomTemplateViewProductSlotCreateSuccessAction> => ({
  type: PRODUCT_SLOT_CREATE_SUCCESS,
  productSlot,
  roomTemplateId,
  [NOTIFICATION]: {
    message: `Produktplats "${productSlot.name}" skapad`,
  },
});

const productSlotCreateFailure = (error: ErrorDto): Exact<RoomTemplateViewProductSlotCreateFailureAction> => ({
  type: PRODUCT_SLOT_CREATE_FAILURE,
  error,
});

export const clear = (): Exact<RoomTemplateViewClearAction> => ({
  type: CLEAR,
});

export const reset = (): Exact<RoomTemplateViewResetAction> => ({
  type: RESET,
});

export const selectProductSlot = (productSlot: ?ProductSlotDto): Exact<RoomTemplateViewSelectProductSlotAction> => ({
  type: SELECT_PRODUCT_SLOT,
  productSlot,
});

export const fetchData = (id: number) => async (dispatch: Dispatch<RoomTemplateViewAction>) => {
  dispatch(roomTemplateRequest());
  try {
    const roomTypes = sortByName(await GET({endpoint: '/roomtypes'}, dispatch));
    const products = await GET({endpoint: `/products?assortment=${STANDARD}`}, dispatch);
    const productTypes = sortByName(await GET({endpoint: '/producttypes'}, dispatch));
    let roomTemplate = null;
    let roomTemplates = [];
    let projects = [];
    if (id) {
      roomTemplate = await GET({endpoint: `/roomtemplates/${id}`}, dispatch);
    } else {
      projects = sortByName(_.map(x => ({
        ...x,
        apartmentConfigs: sortByName(x.apartmentConfigs),
      }), await GET({endpoint: '/projects/rooms'}, dispatch)));
      roomTemplates = filterAndSort(await GET({endpoint: '/roomtemplates'}, dispatch));
    }
    dispatch(roomTemplateSuccess(roomTemplate, roomTypes, products, productTypes, roomTemplates, projects));
  } catch (err) {
    dispatch(roomTemplateFailure(err));
  }
};

export const updateRoomTemplate = (id: number, body: any) => async (dispatch: Dispatch<RoomTemplateViewAction>) => {
  dispatch(roomTemplateUpdateRequest());
  try {
    const roomTemplate = await PUT({
      endpoint: `/roomtemplates/${id}`,
      body,
    }, dispatch);
    dispatch(roomTemplateUpdateSuccess(roomTemplate));
  } catch (err) {
    dispatch(roomTemplateUpdateFailure(err));
  }
};

export const createRoomTemplate = (body: any) => async (dispatch: Dispatch<RoomTemplateViewAction>) => {
  dispatch(roomTemplateCreateRequest());
  try {
    const roomTemplate = await POST({
      endpoint: '/roomtemplates',
      body,
    }, dispatch);
    dispatch(roomTemplateCreateSuccess(roomTemplate));
  } catch (err) {
    dispatch(roomTemplateCreateFailure(err));
  }
};

export const createProductSlot = (roomTemplateId: number, body: any) => async (dispatch: Dispatch<RoomTemplateViewAction>) => {
  dispatch(productSlotCreateRequest());
  try {
    const productslot = await POST({
      endpoint: `/roomtemplates/${roomTemplateId}/productslots`,
      body,
    }, dispatch);
    dispatch(productSlotCreateSuccess(productslot, roomTemplateId));
  } catch (err) {
    dispatch(productSlotCreateFailure(err));
  }
};

export const updateProductSlot = (id: number, body: any) => async (dispatch: Dispatch<RoomTemplateViewAction>) => {
  dispatch(productSlotUpdateRequest());
  try {
    const productslot = await PUT({
      endpoint: `/productslots/${id}`,
      body,
    }, dispatch);
    dispatch(productSlotUpdateSuccess(productslot));
  } catch (err) {
    dispatch(productSlotUpdateFailure(err));
  }
};

export const updateProductSlots = (roomTemplateId: number, productSlotId: number, sortDirection: 'up' | 'down') => async (dispatch: Dispatch<RoomTemplateViewAction>) => {
  dispatch(productSlotsUpdateRequest());
  try {
    const productSlots = await PUT({
      endpoint: `/roomtemplates/${roomTemplateId}/productslots`,
      body: {
        productSlotId,
        sortDirection,
      },
    }, dispatch);
    dispatch(productSlotsUpdateSuccess(roomTemplateId, productSlotId, productSlots));
  } catch (err) {
    dispatch(productSlotsUpdateFailure(err));
  }
};



// WEBPACK FOOTER //
// ./src/actions/roomTemplateView.js